<script lang="ts">
  import { TwistDivider } from '@twist/core';
  import type { MediaKitLandingPage } from '$lib/sanity/schemas';
  import Container from '../News/Container.svelte';
  import AssetSection from './AssetSection.svelte';
  import MoreMediaSection from './MoreMediaSection.svelte';
  import MediakitPageHeader from './MediakitPageHeader.svelte';
  import { type ContentSourceMap, type StudioPathLike } from '@sanity/svelte-loader';

  export let document: MediaKitLandingPage;
  export let sourceMap: ContentSourceMap | undefined = undefined;
  export let path: StudioPathLike = [];
</script>

<MediakitPageHeader {document} {sourceMap} {path} />

{#each document.assetSections as assetSection, index}
  <AssetSection {sourceMap} path={[...path, 'assetSections', index]} document={assetSection} />
  <Container>
    <TwistDivider thickness="1px" margin={0} />
  </Container>
{/each}

<Container>
  <MoreMediaSection {sourceMap} path={[...path, 'moreMedia']} document={document.moreMedia} />
</Container>
